import { ERROR_CODES, type ErrorCode } from "./codes";
import { HTTP_STATUS } from "./http-status";
import { publicErrorDetails } from "./redaction";

export const APP_ERROR_BRAND = Symbol.for("imiker-crm.AppError");

/**
 * 统一的应用错误类
 *
 * 所有业务错误都应使用此类或其工厂函数创建
 */
export class AppError extends Error {
  readonly [APP_ERROR_BRAND] = true;
  readonly code: ErrorCode;
  readonly statusCode: number;
  readonly details?: unknown;
  readonly isOperational: boolean;

  constructor(
    message: string,
    code: ErrorCode = ERROR_CODES.INTERNAL_SERVER_ERROR,
    statusCode: number = HTTP_STATUS.INTERNAL_SERVER_ERROR,
    details?: unknown,
    isOperational = true,
  ) {
    super(message);
    this.name = "AppError";
    this.code = code;
    this.statusCode = statusCode;
    this.details = details;
    this.isOperational = isOperational;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AppError);
    }
  }

  /**
   * Convert error to JSON response format
   */
  toJSON() {
    return {
      error: {
        message: this.message,
        code: this.code,
        statusCode: this.statusCode,
        ...(this.details !== undefined && this.statusCode < HTTP_STATUS.INTERNAL_SERVER_ERROR
          ? { details: publicErrorDetails(this.details) }
          : {}),
      } as {
        message: string;
        code: ErrorCode;
        statusCode: number;
        details?: unknown;
        requestId?: string;
      },
    };
  }
}
